import React, { useState } from 'react';
import { useEffect } from 'react';
import { AiFillHeart } from 'react-icons/ai';
import { AiOutlineHeart } from 'react-icons/ai';
import { MdBlock } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';

import Tooltip from '@material-ui/core/Tooltip';

import { useAuth } from '~/hooks/auth';
import { IState } from '~/store';
import {
  createFavoriteProcessRequest,
  deleteFavoriteProcessRequest,
} from '~/store/modules/processes/actions';
import colors from '~/styles/colors';

import OverflowText from '../OverflowText';
import {
  CardContainer,
  CardContent,
  CardHeader,
  ButtonContainer,
  RequestButton,
  CardDescription,
  FavoriteButton,
} from './styles';

interface SolicitationCardProps {
  title: string;
  processDefinitionKey: string;
  isSuspended: boolean;
  // eslint-disable-next-line react/require-default-props
  favorite?: boolean;
  // eslint-disable-next-line react/require-default-props
  onClick?: () => void;
}

const SolicitationCard = ({
  title,
  processDefinitionKey,
  favorite = false,
  isSuspended,
  ...props
}: SolicitationCardProps) => {
  const [isFavorite, setIsFavorite] = useState(false);
  const DISABLED_MESSAGE =
    'Este processo está bloqueado temporariamente e não pode receber solicitações. Em caso de dúvidas contate seu gestor ou o suporte do Wedo.';

  const favoriteProcesses = useSelector(
    (state: IState) => state.processes.favoriteProcesses,
  );

  const { user } = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    const hasFavorite = favoriteProcesses?.some(
      (favoriteProcess) => favoriteProcess.key === processDefinitionKey,
    );

    if (hasFavorite) {
      setIsFavorite(true);
    } else {
      setIsFavorite(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favoriteProcesses]);

  const handleFavoriteProcess = () => {
    dispatch(
      createFavoriteProcessRequest(
        user.personId,
        processDefinitionKey,
        user.orgId,
      ),
    );
  };

  const handleRemoveFavoriteProcess = () => {
    dispatch(deleteFavoriteProcessRequest(user.personId, processDefinitionKey));
  };

  return (
    <CardContainer>
      <CardHeader>
        <ButtonContainer>
          {isSuspended && (
            <Tooltip
              title={DISABLED_MESSAGE}
              disableHoverListener={!isSuspended}
              arrow
            >
              <button
                type="button"
                style={{ marginRight: '4px', cursor: 'help' }}
              >
                <MdBlock size={20} color={colors.primary} />
              </button>
            </Tooltip>
          )}
          <FavoriteButton
            type="button"
            onClick={() => {
              setIsFavorite(!isFavorite);

              favorite === true
                ? handleRemoveFavoriteProcess()
                : handleFavoriteProcess();
            }}
          >
            {isFavorite === false ? (
              <AiOutlineHeart size={20} />
            ) : (
              <AiFillHeart size={20} color={colors.primary} />
            )}
          </FavoriteButton>
        </ButtonContainer>
      </CardHeader>
      <CardContent>
        <CardDescription>
          <OverflowText
            title={title}
            lines={2}
            style={{ maxWidth: '193px' }}
            tooltipPlacement="top"
            isInteractive={false}
          >
            <span>{title}</span>
          </OverflowText>
        </CardDescription>

        <RequestButton {...props} type="button" disabled={isSuspended}>
          Solicitar
        </RequestButton>
      </CardContent>
    </CardContainer>
  );
};

export default SolicitationCard;
